import { Slider } from 'antd'
import { usePointCloudContext } from 'features/pointClouds'
import {
  SliderContainer,
  SliderLabel,
  SliderRow,
  SliderValue,
} from 'pages/pointClouds/components/hud/controlPanel/ControlPanel.styles'
import React from 'react'

// Helper function to format large numbers
const formatNumber = (num: number): string => {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1)}M`
  } else if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}K`
  }
  return num.toString()
}

export const PointSettings: React.FC = () => {
  const { pointBudget, pointSize, setPointBudget, setPointSize } =
    usePointCloudContext()
  return (
    <>
      <SliderRow>
        <SliderLabel>
          Point Budget: <SliderValue>{formatNumber(pointBudget)}</SliderValue>
        </SliderLabel>
        <SliderContainer>
          <Slider
            value={pointBudget}
            min={100000}
            max={50000000}
            step={100000}
            onChange={(value) => setPointBudget(value)}
          />
        </SliderContainer>
      </SliderRow>

      <SliderRow>
        <SliderLabel>
          Point Size: <SliderValue>{pointSize.toFixed(2)}</SliderValue>
        </SliderLabel>
        <SliderContainer>
          <Slider
            value={pointSize}
            min={0.1}
            max={2}
            step={0.05}
            onChange={(value) => setPointSize(value)}
          />
        </SliderContainer>
      </SliderRow>
    </>
  )
}
